import { render } from "./Pedidos.vue?vue&type=template&id=e5447f56&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"

import "./Pedidos.vue?vue&type=style&index=0&id=e5447f56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5447f56"]])

export default __exports__